import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
    this.state = {
      form: {
        name: '',
        phoneNumber: '',
        email: '',
        appealCategory: '',
        idNumber: '',

        contactAddress: '',
        title: '',
        content: '',
        // attachmentPath: '',  // 上传路径
        veriCode: '',
        attachmentName: '',
        attachmentPath: '',
      },
      veriCodeAns: '',
      veriCodeImg: '',
      attachmentNameOut: '',  // 文件名
      attachmentPathOut: '',  // 文件路径
      fileOut: '',
      fileListOut: '',

    };
  }

  componentDidMount() {
    const idVal = Request.GetUrlParam('id');//获取地址栏参数
    Http.get(Request.consultationmailboxDetail(), { "id": idVal }, obj => {
      console.log('opinionsMailBoxObj---', obj)
      if (obj) {
        this.setState({
          form: obj.data
        })
      }
    });

  }


  render() {
    const { form } = this.state;

    return (
      <div className="complaint-container">
        <fieldset disabled>
          <Form ref="form" model={form} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
                <span className="title">网上征求意见信箱详情</span>
              </Col>
              <Col sm={{ span: 10 }}>
                <Form.Item label="姓名" props="name" >
                  <Input value={form.name} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 10, offset: 4 }}>
                <Form.Item label="手机号码" props="phoneNumber" >
                  <Input value={form.phoneNumber}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 10 }}>
                <Form.Item label="电子邮箱" props="email" >
                  <Input value={form.email} ></Input>
                </Form.Item>
              </Col>
              {/* <Col sm={{ span: 10, offset: 4 }}>
                <Form.Item label="诉求类别" props="appealCategory" >
                  <Select value={form.appealCategory.toString()} placeholder="请选择">
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'appeal_category') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item)=>{
                              return <Select.Option key={item.dictkey} label={item.dictValue} value={Number(item.dictkey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col> */}
              <Col sm={{ span: 24 }}>
                <Form.Item label="身份证号" props="idNumber" >
                  <Input value={form.idNumber} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="联系地址" props="contactAddress" >
                  <Input value={form.contactAddress}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="标题" props="title" >
                  <Input value={form.title}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="内容" props="content" >
                  <Input
                    type="textarea"
                    autosize={{ minRows: 10, maxRows: 20 }}
                    value={form.content}

                  />
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="附件" props="category">
                  <a target="_blank" href={form.attachmentPath ? form.attachmentPath.replace("blob:", '') : ''}><img src={form.attachmentPath} alt="" width='200px' /></a>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </fieldset>
      </div>
    );
  }
}
